import "./ConfirmationModal.scss";

import React from "react";

import { Button, Modal, Typography } from "antd";
import PropTypes from "prop-types";

import { modalBodyStyle } from "../../Utils/constants";

const ConfirmationModal = ({
  open,
  afterClose,
  title,
  message,
  onConfirm,
  onCancel,
  confirmButtonText = "Yes",
  cancelButtonText = "Cancel",
  confirmButtonVariant = "",
  cancelButtonVariant = "outlineBtn",
  showConfirmButton = true,
  showCancelButton = true,
  confirmLoading = false,
  cancelLoading = false,
  confirmDisabled = false,
  cancelDisabled = false,
  centered = true,
  footer = null,
  className,
  wrapClassName,
  bodyStyle,
  titleStyle,
  customContent,
  ...props
}) => {
  const handleClose = () => {
    onCancel();
    afterClose?.();
  };

  return (
    <Modal
      title={
        <div className="activityPostModalTitleWrapper">
          <Typography.Title
            level={4}
            className="activityPostModalTitle"
            style={{ textAlign: "left", ...titleStyle }}
          >
            {title}
          </Typography.Title>
        </div>
      }
      centered={centered}
      footer={footer}
      visible={open}
      onOk={onConfirm}
      onCancel={handleClose}
      className={`createPostModalv2 ${className || ""}`}
      bodyStyle={{ ...modalBodyStyle, ...bodyStyle }}
      wrapClassName={`createPostModalDialogv2 ${wrapClassName || ""}`}
      maskClosable={false}
      {...props}
    >
      <>
        {customContent || (
          <div className="confirmationModalMain">
            <Typography.Text className="text">
              {message || "Are you sure you want to leave the page?"}
            </Typography.Text>
          </div>
        )}
      </>

      {showConfirmButton || showCancelButton ? (
        <div className="confirmationModalFooter">
          {showCancelButton && (
            <Button
              className={`siteBtn grayBtn ${cancelButtonVariant}`}
              onClick={onCancel}
              loading={cancelLoading}
              disabled={confirmLoading || cancelLoading || cancelDisabled}
              block
            >
              {cancelButtonText}
            </Button>
          )}

          {showConfirmButton && (
            <Button
              className={`siteBtn accentBtnV1 ${confirmButtonVariant}`}
              onClick={onConfirm}
              loading={confirmLoading}
              disabled={confirmLoading || confirmDisabled}
              block
            >
              {confirmButtonText}
            </Button>
          )}
        </div>
      ) : null}
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  afterClose: PropTypes.func,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  confirmButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  confirmButtonVariant: PropTypes.string,
  cancelButtonVariant: PropTypes.string,
  showConfirmButton: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  confirmLoading: PropTypes.bool,
  cancelLoading: PropTypes.bool,
  confirmDisabled: PropTypes.bool,
  cancelDisabled: PropTypes.bool,
  centered: PropTypes.bool,
  footer: PropTypes.node,
  className: PropTypes.string,
  wrapClassName: PropTypes.string,
  bodyStyle: PropTypes.shape({}),
  titleStyle: PropTypes.shape({}),
  customContent: PropTypes.node,
};

export default ConfirmationModal;
